import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {APP_ROUTES} from './routes';

export const IMPORTS = [
  FormsModule,
  BrowserModule,
  ReactiveFormsModule,
  HttpClientModule,
  RouterModule.forRoot(APP_ROUTES, {useHash: true})
];




// WEBPACK FOOTER //
// ./src/app/app.module.imports.ts